import { OfferStatusDto } from "common/enums/enums";

export const isNewStatus = (status: OfferStatusDto) => status === OfferStatusDto.PreApplicationPaid;

export const isRequestBackgroundCheckAvailable = (status: OfferStatusDto) => status !== OfferStatusDto.PreApplicationRejected 
  && status !== OfferStatusDto.Reject
  && status !== OfferStatusDto.IncompleteOffer;

export const acceptAvailable = (status: OfferStatusDto) => status === OfferStatusDto.PreApplicationPaid 
  || status === OfferStatusDto.BackgroundCheckRequested
  || status === OfferStatusDto.BackgroundCheckInitiated
  || status === OfferStatusDto.BackgroundCheckCompleted
  || status === OfferStatusDto.CreditCheckCompleted;

export const rejectAvailable = (status: OfferStatusDto) => status === OfferStatusDto.PreApplicationPaid 
  || status === OfferStatusDto.BackgroundCheckRequested
  || status === OfferStatusDto.BackgroundCheckInitiated
  || status === OfferStatusDto.BackgroundCheckCompleted
  || status === OfferStatusDto.PreApplicationAccepted
  || status === OfferStatusDto.CreditCheckCompleted;

export const isSendLeaseAvaialable = (status: OfferStatusDto) => status === OfferStatusDto.PreApplicationAccepted 
